import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 项目详情
  mobileprojectdetail(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/project/detail',
      method: 'get',
      params: args
    })
  },
  // 项目全部设备列表
  mobileprojectdevice(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/project/device',
      method: 'get',
      params: args
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/projectInfo/index.js